import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MaskedLines } from "@/components/motion/Reveal";
import ScrambleText from "@/components/motion/ScrambleText";
import Magnetic from "@/components/motion/Magnetic";

export default function CTASection() {
  return (
    <section data-testid="cta-section" className="relative overflow-hidden bg-accent text-bone">
      <span
        aria-hidden="true"
        className="pointer-events-none absolute -right-12 -top-24 select-none font-display text-[42vw] font-extrabold leading-none text-bone/[0.07] md:text-[28vw]"
      >
        #
      </span>
      <div className="relative mx-auto max-w-[1600px] px-5 py-20 sm:py-24 md:py-28 lg:py-36 xl:py-40 sm:px-8 md:px-10 lg:px-12 xl:px-16">
        <ScrambleText as="p" text="Have a brief?" className="mb-6 block text-xs md:mb-8 font-bold uppercase tracking-[0.22em] text-bone/70" />
        <MaskedLines
          as="h2"
          lines={["Send us", "your brief."]}
          className="font-display text-[16vw] font-extrabold leading-[0.85] tracking-tighter md:text-[11vw]"
        />
        <div className="mt-10 flex flex-col gap-6 sm:mt-12 md:flex-row md:items-center md:justify-between">
          <p className="max-w-md text-lg text-bone/80">
            Tell us what you're building. We'll come back with a point of view, not a pitch template.
          </p>
          <Magnetic strength={0.35}>
            <Link
              to="/contact"
              data-testid="cta-section-button"
              className="group inline-flex items-center gap-3 border border-bone bg-bone px-8 py-5 text-sm font-bold uppercase tracking-[0.14em] text-ink transition-colors duration-300 hover:bg-transparent hover:text-bone"
            >
              Start a conversation
              <ArrowUpRight size={18} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </Magnetic>
        </div>
      </div>
    </section>
  );
}
